import { format, isToday, parseISO } from 'date-fns';

interface PlannerColumnHeaderProps {
  date: string;
  scheduledHours?: number;
}

export function PlannerColumnHeader({
  date,
  scheduledHours = 0,
}: PlannerColumnHeaderProps) {
  const parsed = parseISO(date);
  const today = isToday(parsed);
  const dayName = format(parsed, 'EEE').toUpperCase();
  const dayNum = format(parsed, 'd');
  const hoursDisplay = Number.isInteger(scheduledHours)
    ? `${scheduledHours}h`
    : `${parseFloat(scheduledHours.toFixed(1))}h`;

  return (
    <div className={`flex flex-col items-center py-2 border-l border-border-subtle/30 ${today ? 'bg-accent/[0.03]' : ''}`}>
      <span className="text-[10px] text-text-muted font-medium tracking-widest leading-none">
        {dayName}
      </span>
      <span
        className={`text-[14px] font-bold leading-none mt-1 w-6 h-6 flex items-center justify-center rounded-full ${
          today ? 'bg-accent text-white' : 'text-text-primary'
        }`}
      >
        {dayNum}
      </span>
      <span className="text-[10px] text-text-muted font-mono leading-none mt-1 tabular-nums">
        {hoursDisplay}
      </span>
    </div>
  );
}
